import { render, staticRenderFns } from "./childAdministrator.vue?vue&type=template&id=4c1c22b6&scoped=true&"
import script from "./childAdministrator.vue?vue&type=script&lang=js&"
export * from "./childAdministrator.vue?vue&type=script&lang=js&"
import style0 from "./childAdministrator.vue?vue&type=style&index=0&id=4c1c22b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1c22b6",
  null
  
)

export default component.exports